import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import Section from "../Section"
import Content from "../Content"
import TeamMemberList from "../TeamMemberList"

const StyledSection = styled(Section)`
  overflow: hidden;

  h2:first-of-type {
    margin-top: 0;
  }

  h2,
  h3 {
    text-transform: uppercase;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    padding: 4rem 0;
  `}
`

const StyledImgWrapper = styled.div`
  img {
    opacity: 0.07;
    position: absolute;
    width: auto;
    height: 100%;
    ${(props) => props.theme.media.tablet_landscape_up`
      opacity: 0.1;
      width: auto;
      right: 0;
      // bottom: 20%;
    `}
  }
`

function About({ content, ...props }) {
  const { list: team_list } = content.team_member_list

  return (
    <>
      <TeamMemberList team_members={team_list} />
      <StyledSection
        bg="ice"
        color="primary"
        left={
          <>
            <StyledImgWrapper>
              <img
                src={content.company_imageSharp?.publicURL}
                alt="pattern"
                draggable="false"
              />
            </StyledImgWrapper>
          </>
        }
      >
        <article>
          <Content content={content.main_content} />
        </article>
      </StyledSection>
    </>
  )
}

export default About

export const query = graphql`
  fragment TeamMemberList on PRISMIC_Team_member_list {
    list {
      team_member {
        ... on PRISMIC_Team_member {
          name
          team_role
          icon
          image
          imageSharp {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          tech_stack {
            technology {
              ... on PRISMIC_Technology {
                name
                icon
              }
            }
          }
        }
      }
    }
  }
`
